module.exports = __webpack_public_path__ + "static/media/consensys-1.bf935c85.jpg";